export default "__VITE_ASSET__CTeFpIQp__"